/* BEBA: Delivery Guarantee.
   1) Renames Stord's cart widget ("Shipment Protection" -> "Delivery Guarantee") and its checkout buttons.
   2) Swaps Stord's generic info modal for the branded BEBA pop-up (snippets/beba-guarantee.liquid).
   Stord's modal is only hidden once this script is running, so the (i) never goes dead if this file fails. */
(function(){
  const dlg=document.getElementById('beba-guarantee');if(!dlg)return;
  document.documentElement.classList.add('beba-g');
  let from=null;
  const open=()=>{from=document.activeElement;
    if(typeof dlg.showModal==='function'){if(!dlg.open)dlg.showModal()}else dlg.setAttribute('open','');
    document.documentElement.classList.add('bg-lock');dlg.querySelector('[data-guarantee-close]').focus()};
  const close=()=>{if(dlg.close)dlg.close();else dlg.removeAttribute('open')};
  dlg.addEventListener('close',()=>{document.documentElement.classList.remove('bg-lock');from&&from.focus&&from.focus()});
  dlg.addEventListener('click',e=>{if(e.target===dlg||e.target.closest('[data-guarantee-close]'))close()});
  window.BEBA=window.BEBA||{};window.BEBA.openGuarantee=open;

  /* Capture phase: runs before Stord's own handler on its (i) button. */
  document.addEventListener('click',e=>{const b=e.target.closest('.stord-sp-info-icon,.stord-sp-info-wrap,[data-guarantee-open]');if(!b)return;
    e.preventDefault();e.stopImmediatePropagation();open()},true);
  document.addEventListener('keydown',e=>{if((e.key==='Enter'||e.key===' ')&&e.target.closest&&e.target.closest('.stord-sp-info-icon')){e.preventDefault();e.stopImmediatePropagation();open()}},true);

  /* Stord re-renders its widget whenever the cart changes, so keep the labels in sync. */
  const TEXT=[
    ['.stord-sp-widget-title','Delivery Guarantee'],
    ['.stord-sp-widget-message','For lost, damaged or stolen packages.'],
    ['.stord-sp-btn-primary','Check out with guarantee'],
    ['.stord-sp-link-secondary','Check out without guarantee']
  ];
  const sync=()=>{TEXT.forEach(([s,t])=>document.querySelectorAll(s).forEach(n=>{
      const tgt=n.querySelector('.button-text')||n;if(tgt.textContent.trim()!==t)tgt.textContent=t}));
    document.querySelectorAll('.stord-sp-info-icon').forEach(b=>{if(!b.getAttribute('aria-label'))b.setAttribute('aria-label','What is the Delivery Guarantee?')})};
  let q=0;const later=()=>{if(!q)q=requestAnimationFrame(()=>{q=0;sync()})};
  sync();new MutationObserver(later).observe(document.body,{childList:true,subtree:true,characterData:true});
})();
